import { useQuery } from '@apollo/client/react';
import { useCallback } from 'react';
import { useSubscription } from '../socket/useSubscription.ts';
import { useCurrentContextStore } from './store/useCurrentContextStore.ts';
import { OPEN_REQUESTS_COUNT_QUERY } from './useOpenRequestsCount.gql';

/**
 * Live count of open Anforderungen for the current doctor. Uses the dedicated
 * `openRequestsCount` query, which shares the exact predicate of the open-requests
 * list (allowed-labs + front-desk filter), so the badge matches the list. Refetched
 * on the request socket events that change membership of the open set.
 */
export const useOpenRequestsCount = (): number | undefined => {
  const { currentDoctorId } = useCurrentContextStore();

  const { data, refetch } = useQuery(OPEN_REQUESTS_COUNT_QUERY, {
    variables: { doctorId: currentDoctorId },
    skip: !currentDoctorId,
    fetchPolicy: 'cache-and-network',
  });

  const callback = useCallback(() => {
    refetch();
  }, [refetch]);

  useSubscription({ type: 'request-created', tenantId: currentDoctorId }, callback);
  useSubscription({ type: 'request-sent', tenantId: currentDoctorId }, callback);
  useSubscription({ type: 'request-deleted', tenantId: currentDoctorId }, callback);

  return data?.openRequestsCount ?? undefined;
};
